import React, { useEffect } from 'react';
import { BrowserRouter, Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { Nav } from './components/Nav';
import { Footer } from './components/Footer';
import { Seo } from './components/Seo';
import { Analytics } from './components/Analytics';
import { Home } from './pages/Home';
import { How } from './pages/How';
import { About } from './pages/About';
import { Contact } from './pages/Contact';
import { Blog } from './pages/Blog';
import { Post } from './pages/Post';
import { Terms } from './pages/Terms';
import { Privacy } from './pages/Privacy';
import { OgCard } from './pages/OgCard';
import { FaviconCard } from './pages/FaviconCard';
function Shell() {
  const location = useLocation();
  useEffect(() => {
    // A hash targets a section once the new page has laid out; otherwise land
    // at the top instantly rather than animating from the previous page.
    const target = location.hash ? document.getElementById(location.hash.slice(1)) : null;
    if (target) {
      target.scrollIntoView({
        behavior: 'auto',
        block: 'start'
      });
      return;
    }
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'auto'
    });
  }, [location.pathname, location.hash, location.search]);
  return <div className="frame" data-id="element-0" data-mp="3rdarmj8qkein">
      <div className="rail" data-id="element-1" data-mp="3rd18nfm3z7mg">
        <Seo pathname={location.pathname} data-id="element-2" data-mp="5yh2n2cyzbp" />
        <Analytics pathname={location.pathname} data-id="element-3" data-mp="4n5i12o8na1" />
        <Nav data-id="element-4" data-mp="2zl3bdjx5744s" />
        <main data-id="element-5" data-mp="2zllf11m4wkmq">
          <Routes data-id="element-6" data-mp="2zlv8iz6e19x6">
            <Route path="/" element={<Home data-id="element-8" data-mp="2zn6b4vo3kbmp" />} data-id="element-7" data-mp="2zmemk4sx3e5x" />
            <Route path="/how" element={<How data-id="element-10" data-mp="33lx02fiesmyq" />} data-id="element-9" data-mp="33morde4z3yj7" />
            <Route path="/about" element={<About data-id="element-12" data-mp="33oi337ug18y2" />} data-id="element-11" data-mp="33n6zp94wu37h" />
            <Route path="/blog" element={<Blog data-id="element-14" data-mp="38kqbm2e4y3w9" />} data-id="element-13" data-mp="38m1fe27kzbnd" />
            {/* Unknown slugs render their own not-found with a route back to Signals. */}
            <Route path="/blog/:slug" element={<Post data-id="element-16" data-mp="3dii5v329623m" />} data-id="element-15" data-mp="3dmfprqwnmxok" />
            <Route path="/contact" element={<Contact data-id="element-18" data-mp="nur6e0oh68xc" />} data-id="element-17" data-mp="nw2bc3tnpmq1" />
            <Route path="/terms" element={<Terms data-id="element-20" data-mp="sudl6ejybx89" />} data-id="element-19" data-mp="nxn69ujvv7of" />
            <Route path="/privacy" element={<Privacy data-id="element-22" data-mp="st2k4mhw53ku" />} data-id="element-21" data-mp="studrrrxgr8h" />
            {/* Legacy .html paths from the original static site. */}
            <Route path="/index.html" element={<Navigate to="/" replace data-id="element-24" data-mp="3uct4hmy40t22" />} data-id="element-23" data-mp="34x29ica5b3w" />
            <Route path="/home.html" element={<Navigate to="/" replace data-id="element-26" data-mp="3uevrdy3yu62k" />} data-id="element-25" data-mp="3ubrhql7qei4i" />
            <Route path="/how.html" element={<Navigate to="/how" replace data-id="element-28" data-mp="d3cwvvain2i5" />} data-id="element-27" data-mp="d57f31uekgij" />
            <Route path="/how-it-works" element={<Navigate to="/how" replace data-id="element-30" data-mp="86mfn4mz60v5" />} data-id="element-29" data-mp="85l1usekr09q" />
            <Route path="/how-it-works.html" element={<Navigate to="/how" replace data-id="element-32" data-mp="3gkl9o0qdzc60" />} data-id="element-31" data-mp="83i6dsunkexm" />
            <Route path="/about.html" element={<Navigate to="/about" replace data-id="element-34" data-mp="3bmjqlfsyncuj" />} data-id="element-33" data-mp="3glnz048296jt" />
            <Route path="/contact.html" element={<Navigate to="/contact" replace data-id="element-36" data-mp="3bkguce17snhd" />} data-id="element-35" data-mp="3bnuv5hu8comp" />
            <Route path="/blog.html" element={<Navigate to="/blog" replace data-id="element-38" data-mp="3qdai0mqn49x4" />} data-id="element-37" data-mp="3qc93u9ebv7b6" />
            <Route path="*" element={<Navigate to="/" replace data-id="element-40" data-mp="3ljpk0up1rfxx" />} data-id="element-39" data-mp="3lk7mi92ayqea" />
          </Routes>
        </main>
        <Footer data-id="element-41" data-mp="2xu3kg64riype" />
      </div>
    </div>;
}
export function App() {
  return <BrowserRouter data-id="element-42" data-mp="2sw207hvlotcc">
      <Routes data-id="element-43" data-mp="2swliizp5xjqw">
        {/* Rendered outside the site frame: they're images to capture, not pages. */}
        <Route path="/og" element={<OgCard data-id="element-45" data-mp="18c6qeaqww4i2" />} data-id="element-44" data-mp="18dhu6akcxc96" />
        <Route path="/favicon" element={<FaviconCard data-id="element-47" data-mp="1d4zsequzwyqg" />} data-id="element-46" data-mp="18bomcry0clzl" />
        <Route path="*" element={<Shell data-id="element-49" data-mp="1d5ssj8zg8pzm" />} data-id="element-48" data-mp="1d5j8e2135d1u" />
      </Routes>
    </BrowserRouter>;
}